import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-beautiful-dnd';
import { FiEye } from 'react-icons/fi';
import uuid from 'uuid/v4';
import {
  Grid,
  Page,
  StickyInPage,
} from '../../components';
import EditFormPanel from './edit/EditFormPanel';
import EditFormFields from './edit/EditFormFields';
import { TEXT_FIELD, DROPDOWN_FIELD } from './fields/FormField';
import api from '../../utils/services';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
      formId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const fieldTypes = [
  TEXT_FIELD,
  DROPDOWN_FIELD,
];

export default class EditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      previewMode: false,
    };
    this.editFormFieldsRef = null;
  }

  componentDidMount() {
    const { match: { params: { formId } } } = this.props;
    api.getFormById(formId)
      .then((data) => {
        this.setState({ form: data });
      });
  }

  createFormElement = elementType => ({
    id: uuid(), // Give it a temporary id until it is persisted (so that it has a stable key)
    uiComponent: elementType,
  })

  togglePreviewMode = () => {
    this.setState(state => ({
      previewMode: !state.previewMode,
    }));
  }

  /* Handle the drag and drop. Permitted flows:
   * source: panel, destination: form (new element)
   * source: form, destination: form (reorder element)
   */
  onDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination // Drop outside of Droppable boundries
      || destination.droppableId === 'EditFormPanel'
    ) {
      return;
    }

    if (source.droppableId === 'EditFormPanel') { // Create new element
      this.setState(state => ({
        form: {
          ...state.form,
          formElements: [
            ...state.form.formElements.slice(0, destination.index),
            this.createFormElement(fieldTypes[source.index]),
            ...state.form.formElements.slice(destination.index),
          ],
        },
      }));
    } else { // Reorder elements
      if (source.index === destination.index) { // no-op (logic below assumes a move)
        return;
      }

      this.setState((state) => {
        const formElements = [...state.form.formElements];
        const [movedItem] = formElements.splice(source.index, 1);
        formElements.splice(destination.index, 0, movedItem);
        return {
          form: {
            ...state.form,
            formElements,
          },
        };
      });
    }
  }

  render() {
    const { match: { params: { formId, carrierId } } } = this.props;
    const { form: { formElements }, previewMode } = this.state;

    return (
      <Page
        title={`Editing form: ${formId}`}
        subtitle="(Saving has not been implemented yet, so View will only show data that has been manually added to the database)"
        secondaryActions={[{
          content: (
            <React.Fragment>
              <FiEye style={{ verticalAlign: 'middle', marginRight: '0.25em' }} />
              View
            </React.Fragment>
          ),
          href: `/carriers/${carrierId}/forms/${formId}`,
        }]}
      >
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Grid>
            <Grid.Item span={4}>
              <StickyInPage top="1em">
                <EditFormPanel
                  fieldTypes={fieldTypes}
                  previewMode={previewMode}
                  togglePreviewMode={this.togglePreviewMode}
                />
              </StickyInPage>
            </Grid.Item>
            <Grid.Item>
              <EditFormFields fields={formElements} previewMode={previewMode} />
            </Grid.Item>
          </Grid>
        </DragDropContext>
      </Page>
    );
  }
}

EditForm.propTypes = propTypes;
